import fetch from 'utils/fetch';
import $ from 'jquery';
import _debug from 'debug';
import moment from 'moment';

const debug = _debug('app::maintenance');

export default function bind() {
  const parseJsonIfMaintenanceFound = res => {
    if (res.status === 200) {
      return res.json();
    }

    return Promise.resolve();
  };

  fetch('/admin/maintenance')
    .then(parseJsonIfMaintenanceFound)
    .then(event => {
      if (event) {
        displayEvent(event);
      } else {
        debug('No maintenance scheduled');
      }
    })
    .catch(() => debug('Error while fetching maintenances'));
}

function displayEvent(event) {
  debug('Maintenance scheduled');
  debug(JSON.stringify(event));

  const date = moment(event.expired_at).format('DD/MM/YYYY à HH:mm');
  const message = `${event.content} le ${date}`;

  $('#navbar .right.menu').prepend(`
    <div class="ui active red item"><i class="alarm icon"></i> ${message}</div>
  `);
}



// WEBPACK FOOTER //
// ./src/plugins/maintenance.js